import { tv } from '~/utils/tv'

export const ContentContainerTitleVariants = tv({
  base: `
    flex w-full items-center gap-twopulse min-w-[1rem] flex-shrink
  `,
})

export const ContentTitleVariants = tv({
  base: `
    text-text-neutral !font-rdmodern font-bold leading-small text-start
    overflow-hidden text-ellipsis whitespace-nowrap w-full block
  `,
  variants: {
    size: {
      tiny: 'text-threeandhalfpulse',
      xs: 'text-fivepulse',
    },
  },
})
